import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';

import { concatWithDot } from 'helpers/string';

import { CHANNELS_NAMES } from '../../utils/form';

export const SalesChannels: React.FC<{ name: string; disabled?: boolean }> = memo(({ name, disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <BorderedCard>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextInputControl
              control={control}
              id={concatWithDot(name, CHANNELS_NAMES.NAME)}
              name={concatWithDot(name, CHANNELS_NAMES.NAME)}
              label={t('marketingAndSales.sales.channels.name')}
              disabled={disabled}
              maxLength={150}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberInputControlled
              control={control}
              id={concatWithDot(name, CHANNELS_NAMES.SHARE)}
              name={concatWithDot(name, CHANNELS_NAMES.SHARE)}
              label={t('marketingAndSales.sales.channels.share')}
              disabled={disabled}
              adornmentType="percentage"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInputControl
              multiline
              control={control}
              id={concatWithDot(name, CHANNELS_NAMES.DESCRIPTION)}
              name={concatWithDot(name, CHANNELS_NAMES.DESCRIPTION)}
              label={t('marketingAndSales.sales.channels.description')}
              minRows={4}
              disabled={disabled}
              maxLength={500}
            />
          </Grid>
        </Grid>
      </BorderedCard>
    </>
  );
});
